import {Box, Flex, Heading, useColorModeValue} from "@chakra-ui/react";
import React from "react";

function CartContainer({children}) {
    const HeaderBG = useColorModeValue('#E8ECED', '#2F2F2F')
    const TextColor = useColorModeValue('black', 'white')
    const ContainerBG = useColorModeValue('#F9FAFA', '#3D3D3D')

    return (
        <Flex direction='column' position='sticky' top={4}>
            <Flex p={4} bg={HeaderBG} borderTopLeftRadius='8px' borderTopRightRadius='8px'>
                <Heading
                    size="md"
                    fontFamily="heading"
                    fontWeight="bold"
                    color={TextColor}
                    lineHeight="1.2"
                >
                    Order Summary
                </Heading>
            </Flex>
            <Box p={4} bg={ContainerBG}>
                <Box>
                    {children}
                </Box>
            </Box>
        </Flex>
    )
}

export default CartContainer